import { render, staticRenderFns } from "./material-issues-list.vue?vue&type=template&id=fd03437e"
import script from "./material-issues-list.vue?vue&type=script&lang=js"
export * from "./material-issues-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports